import type Highcharts from "highcharts";

// USAGE: import Highcharts and this init, then call initTooltipShowDelay(Highcharts) once (e.g. in the component that uses the chart).

export function initTooltipShowDelay(H: typeof Highcharts): void {
  H.wrap(
    H.Tooltip.prototype,
    "refresh",
    function (
      this: Highcharts.Tooltip & {
        timer?: number;
        options: Highcharts.TooltipOptions & { showDelay?: number };
      },
      proceed,
      _points,
      ...restArgs: unknown[]
    ) {
      const showDelay = this.options.showDelay || 0;

      if (this.timer) {
        clearTimeout(this.timer);
        delete this.timer;
      }
      if (this.chart.hoverPoint) {
        this.timer = window.setTimeout(() => {
          proceed.apply(this, [_points, ...restArgs]);
        }, showDelay);
      }
    },
  );

  H.addEvent(H.Chart, "load", function (this: Highcharts.Chart) {
    this.container.addEventListener("mouseout", () => {
      if (!this.hoverPoint) {
        const tooltip = this.tooltip as Highcharts.Tooltip & { timer?: number };
        tooltip.hide();
        if (tooltip.timer) {
          clearTimeout(tooltip.timer);
          delete tooltip.timer;
        }
      }
    });
  });
}
